import {ConsumerInformation, EOrderStatus, Order} from '../../entities/inventory/order';

export function makeOrder(existing?: Order): Order {
  return existing ?? {
    id: '',
    approvedById: '',
    isWithdrawal: true,
    consumerInformationId: '',
    organization: '',
    orderStatus: EOrderStatus.Unapproved,
    orderItems: [],
    consumerInformation: makeConsumerInformation(),
    approvedAt: '',
    submittedAt: '',
    totalCost: 0,
    programId: '',
    houseId: '',
    isFromWarehouse: true
  };
}

export function makeDeposit(existing?: Order): Order {
  return existing ?? {
    id: '',
    approvedById: '',
    isWithdrawal: false,
    consumerInformationId: '',
    organization: '',
    orderStatus: EOrderStatus.Approved,
    orderItems: [],
    consumerInformation: makeConsumerInformation(),
    approvedAt: '',
    submittedAt: '',
    totalCost: 0,
    programId: '',
    houseId: '',
    isFromWarehouse: true
  };
}

export function makeConsumerInformation(existing?: ConsumerInformation): ConsumerInformation {
  return existing ?? {
    id: '',
    name: '',
    jobTitle: '',
    emailAddress: '',
    phoneNumber: '+1',
    everythingFound: true,
    everythingFoundComment: '',
    additionalComment: ''
  };
}
